<template lang="pug">
  .event-list
    Heading.dark(theme="section-header") Schedule
    AppListItem(
      v-for="event in future"
      :key="event.link"
      :text="event.title"
      :link="event.link"
      :description="event.description"
      :badge="event.time"
    )
      template(#badges)
        .live.event-badge(v-if="event.live") LIVE
    Heading.dark(theme="section-header" v-if="past.length") Past Events
    AppListItem(
      v-for="event in past"
      :key="event.link"
      :text="event.title"
      :link="event.link"
      :description="event.description"
      :badge="event.time"
    )
      template(#badges)
        .replay.event-badge(v-if="event.hasReplay") REPLAY
</template>
<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import Heading from '../core/Heading.vue'

type Event = {
  title: string,
  description: string,
  link: string,
  startTime: string,
  endTime: string,
  hasReplay?: boolean,
}

const props = withDefaults(defineProps<{
  events?: Event[],
}>(), {
  events: () => ([]),
})

const ts = ref(new Date())

const eventData = computed(() => {
  return props.events.map(e => Object.assign({}, e, {
    live : e.startTime && e.endTime && new Date(e.startTime) < ts.value && new Date(e.endTime) > ts.value,
    time : `${new Date(e.startTime).toLocaleTimeString(undefined, { day: '2-digit', month: '2-digit', hour: 'numeric', minute: '2-digit' })}`,
    past : new Date(e.endTime) < ts.value,
  }))
})
const future = computed(() => eventData.value.filter(e => !e.past))
const past = computed(() => eventData.value.filter(e => e.past))

let liveInterval: NodeJS.Timeout
onMounted(() => {
  liveInterval = setInterval(() => ts.value = new Date(), 10000)
})

onBeforeUnmount(() => {
  clearInterval(liveInterval)
})
</script>
<style lang="scss" scoped>

.event-badge {
  color: $color-white;
  padding: 2px 8px;
  font-size: $size-xxs;
  text-transform: uppercase;
  font-weight: bold;
  font-family: $font-header;
  margin-left: $space-m;

  &.live {
    background-color: $color-red;
  }

  &.replay{
    background-color: $color-black;
  }
}
</style>
